import { FC } from "react";
import { Solution } from "./Solution";
import "./Solutions.scss";
import clock from "../../assets/clock.jpeg";
import network from "../../assets/network.jpg";
import server from "../../assets/servers.jpeg";
import classroom from "../../assets/classroom.jpeg";
import code from "../../assets/computerScreen2.jpg";
import SolutionsList from "./Solutions.json";

const runners = [
  "Full life-cycle support",
  "Program and project management",
  "Financial management and administration",
  "Process improvement and engineering",
  "Risk management",
  "Cost reduction and innovation",
  "Logistics and acquisition",
  "Monitoring, maintenance, and upgrade",
  "Documentation development",
  "Testing and certification",
  "IV&V",
];

function getImage(img: string | undefined): string | undefined {
  switch (img) {
    case "clock":
      return clock;
    case "network":
      return network;
    case "server":
      return server;
    case "classroom":
      return classroom;
    case "code":
      return code;
    default:
      return undefined;
  }
}

export const Solutions: FC = () => {
  return (
    <div className="Solutions">
      <div className="Solutions__header page-header">
        <h1>Solutions</h1>
        <p>
          PROSOFT has an established reputation for providing our clients
          superlative support in four distinct areas of expertise: Program
          Management & Administrative Services, Systems & Software Engineering,
          Network & Infrastructure Engineering, and Training Development &
          Delivery.
        </p>
      </div>
      <div className="Solutions__body">
        <div className="Solutions__body__list">
          {SolutionsList.solutions.map((solution, i) => (
            <Solution
              header={solution.header}
              content={solution.content}
              breakdown={solution.breakdown}
              img={solution.img ? getImage(solution.img) : ""}
              even={i % 2 === 0}
            />
          ))}
        </div>
        <div className="Solutions__body__runner">
          <h2>Supported & Enhanced By:</h2>
          <ul>
            {runners.map((runner) => {
              return <li>{runner}</li>;
            })}
          </ul>
        </div>
      </div>
    </div>
  );
};
